"use strict";

define('layout/overlay.layout',['require','exports','module','marionette','uikit/uikit','uikit/helper/dom','../templates'],function (require, exports, module) {
  var Mn = require('marionette'),
    UIKit = require('uikit/uikit'),
    DOMHelper = require('uikit/helper/dom'),
    Templates = require('../templates');
  var ComponentMixin = UIKit.ComponentMixin;
  var ButtonView = UIKit.Button;
  var TextView = UIKit.Text;
  var ContainerView = UIKit.Container;
  var OverlayLayout = Mn.LayoutView.extend(ComponentMixin).extend({
    template: Templates.IRB['overlay.layout'],
    attributes: {
      style: 'display: none; margin-top: 120px; position: absolute; top: 0px; right: 0px; height: calc(100% - 120px); left: 0px; z-index: 881;'
    },
    regions: {
      content: {
        selector: '.content',
        regionClass: Mn.Region.extend({
          onSwapOut: function onSwapOut(current) {
            this.stopListening(current);
          },
          onShow: function onShow(view) {
            this.listenTo(view, 'before:destroy', function () {
              this._parent._parent.active = false;
            });
          },
          show: function show(view, options) {
            var component = this._parent._parent;
            var keys = _.keys(component.constructor.prototype.options);
            var ret = Mn.Region.prototype.show.call(this, view, _.extend({}, options, {
              preventDestroy: true
            }));
            _.each(_.pick(options, keys), function (val, key) {
              component[key] = val;
            });
            return ret;
          }
        })
      }
    },
    options: {
      active: false,
      container: document.body,
      visible: false,
      background: '#eceeed',
      animation: 'slide left',
      padding: '2em',
      dimmerBackground: 'rgba(255, 255, 255, 0.7)',
      boxShadow: '0px 0px 2px 1px rgba(39, 41, 43, 0.15), 1px 0px 2px 0 rgba(0, 0, 0, 0.05)',
      opacity: '1',
      offset: '7%',
      buttonType: 'close',
      cancelable: false,
      size: null
    },
    update: {
      active: false,
      background: false,
      offset: false,
      buttonType: false,
      cancelable: false,
      button: false,
      header: false,
      subHeader: false,
      size: false
    },
    events: {
      'click': function click(ev) {
        if (!ev.originalEvent) {
          ev.originalEvent = {};
        }
        ev.originalEvent._fromOverlay = true;
        this.triggerMethod('press', this, this.model);
      }
    },
    triggers: {
      'click > .dimmer': {
        event: 'dimmer:press',
        preventDefault: false,
        stopPropagation: false
      },
      'click .offset > .content': {
        event: 'content:press',
        preventDefault: false,
        stopPropagation: false
      }
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.cancelButton = new ButtonView({
        text: 'Cancel',
        color: 'white',
        visible: false,
        floated: 'right'
      });
      this.button = new ButtonView({
        floated: 'right'
      });
      this.header = new TextView({
        attributes: {
          role: 'heading',
          'aria-level': '1'
        }
      });
      this.buttonContainer = new ContainerView();
      this.subHeader = new TextView();
      this.updateButtonType();
      this.listenTo(Backbone.history, 'route', function () {
        this.active = false;
      });
    },
    onButtonPress: function onButtonPress() {
      this.active = false;
      this.triggerMethod(this.buttonType, this);
    },
    onCancelButtonPress: function onCancelButtonPress() {
      if (this.cancelable) {
        this.triggerMethod('cancel', this);
        this.active = false;
      }
    },
    onContainerPress: function onContainerPress() {
      this.active = false;
    },
    onDimmerPress: function onDimmerPress() {
      this.active = false;
      this.triggerMethod('leaving', this);
    },
    _bindContainerClick: function _bindContainerClick() {
      var onClick = _.bind(function (ev) {
        var target = ev.target;
        if (target.tagName == 'A' && $(target).parent().hasClass('redactor-link-tooltip')) {
          return;
        }
        if (!ev.originalEvent._fromOverlay) {
          this.triggerMethod('container:press');
        }
      }, this);
      var $container = $(this.container).on('click.overlay', onClick);
      var previousOverflow = $container.css('overflow'),
        previousStyle = String($container.attr('style') || '');
      $container.css('overflow', 'hidden');
      this.on('change:active', function () {
        $(document.body).off('click.overlay.ignore');
        app.topMenu.$el.off('click.overlay.ignore');
        $container.off('click.overlay', onClick).css('overflow', previousStyle.indexOf('overflow') > -1 ? previousOverflow : '');
      });
      app.topMenu.$el.on('click.overlay.ignore', function (ev) {
        if (!ev.originalEvent) {
          ev.originalEvent = {};
        }
        ev.originalEvent._fromOverlay = true;
      });
      $(document.body).on('click.overlay.ignore', '> .modal', function (ev) {
        if (!ev.originalEvent) {
          ev.originalEvent = {};
        }
        ev.originalEvent._fromOverlay = true;
      }).on('click.overlay.ignore', '.ui.modals', function (ev) {
        if (!ev.originalEvent) {
          ev.originalEvent = {};
        }
        ev.originalEvent._fromOverlay = true;
      }).on('click.overlay.ignore', '.redactor_box', function (ev) {
        if (!ev.originalEvent) {
          ev.originalEvent = {};
        }
        ev.originalEvent._fromOverlay = true;
      }).on('click.overlay.ignore', '.redactor_fullscreen', function (ev) {
        if (!ev.originalEvent) {
          ev.originalEvent = {};
        }
        ev.originalEvent._fromOverlay = true;
      }).on('click.overlay.ignore', '.redactor_dropdown', function (ev) {
        if (!ev.originalEvent) {
          ev.originalEvent = {};
        }
        ev.originalEvent._fromOverlay = true;
      }).on('click.overlay.ignore', '#redactor_modal', function (ev) {
        if (!ev.originalEvent) {
          ev.originalEvent = {};
        }
        ev.originalEvent._fromOverlay = true;
      }).on('click.overlay.ignore', '.redactor-link-tooltip', function (ev) {
        if (!ev.originalEvent) {
          ev.originalEvent = {};
        }
        ev.originalEvent._fromOverlay = true;
      });
    },
    onFirstRender: function onFirstRender() {
      var self = this,
        $container = $(this.container);
      this.on('change:active', _.debounce(function () {
        if (this.active) {
          var scrollTop = $container.scrollTop();
          if ($container.get(0) == document.body) {
            scrollTop = $(document).scrollTop();
          }
          this.$el.css('top', scrollTop);
          this.show({
            animation: this.animation,
            onComplete: function onComplete() {
              self.triggerMethod('shown');
            }
          });
          this._bindContainerClick();
        } else {
          this.hide({
            animation: this.animation,
            onComplete: function onComplete() {
              if (self.content && self.content.$el) {
                self.content.$el.attr('style', '');
              }
              self.cancelable = false;
              self.buttonType = 'close';
              self.size = null;
              self.header.model = null;
              self.subHeader.model = null;
              self.header.text = '';
              self.subHeader.text = '';
              self.buttonContainer.removeAll({
                destroy: true
              });
              self.triggerMethod('confirm');
              self.triggerMethod('hidden');
            }
          });
        }
      }, 1), this).on('change:cancelable', function () {
        this.cancelButton.visible = !!this.cancelable;
      }).on('change:size', this.updateSize).on('render', this.updateSize).on('change:buttonType', this.updateButtonType).on('destroy', function () {
        $(document.body).off('.overlay');
      });
      $(document.body).on('keydown.overlay', function (ev) {
        if (!self.visible) {
          return;
        }
        DOMHelper.stickFocusWithinElement(ev, self.el);
      });
      $(document.body).on('resize.overlay', resize);
      $(window).on('resize.overlay', resize);
      function resize() {
        self.updateSize();
      }
      ;
      this.updateSize();
    },
    updateSize: function updateSize() {
      var $el = this.$('.offset'),
        offset = '7%',
        smallScreen = window.innerWidth <= 992;
      switch (this.size) {
        case 'mini':
          if (smallScreen) {
            offset = '50%';
          } else {
            offset = '70%';
          }
          break;
        default:
          if (smallScreen) {
            offset = '0%';
          }
          break;
      }
      $el.css('left', offset);
    },
    updateButtonType: function updateButtonType() {
      var base = {
        size: '',
        inline: false,
        icon: '',
        text: '',
        basic: false,
        iconRight: false
      };
      switch (this.buttonType) {
        case 'close':
          _.extend(base, {
            color: 'white',
            text: 'Close'
          });
          break;
        case 'done':
          _.extend(base, {
            color: 'primary',
            text: 'Done',
            icon: 'check'
          });
          break;
        case 'save':
          _.extend(base, {
            color: 'primary',
            text: 'Save',
            icon: 'save'
          });
          break;
        case 'next':
          _.extend(base, {
            color: 'secondary',
            text: 'Next',
            icon: 'arrow right',
            iconRight: true
          });
          break;
      }
      _.each(base, function (val, key) {
        this.button[key] = val;
      }, this);
    },
    updateAttributes: function updateAttributes() {}
  });
  module.exports = OverlayLayout;
});

